import React from 'react'
import emailjs from 'emailjs-com';
import PageTitle from './PageTitle'
import './css/Style.min.css'
import './css/Responsive.min.css'
export default function Contact() {

    function sendEmail(e) {
        e.preventDefault();

        let name = document.getElementById("name")
        let subject = document.getElementById("subject")
        let email = document.getElementById("email")
        let message = document.getElementById("message")
        if (name.value === "") {
            name.placeholder = "Please enter your name"
            name.focus()
            return false
        }
        else if (subject.value === "") {
            subject.placeholder = "Please enter your name"
            subject.focus()
            return false
        }
        else if (email.value === "") {
            email.placeholder = "Please enter your name"
            email.focus()
            return false
        }
        else if (message.value === "") {
            message.placeholder = "Please enter your name"
            message.focus()
            return false
        }

        else {
            emailjs.sendForm('service_t2nhd7b', 'template_7auuwkc', e.target, 'user_RZH87QdczFNx2o65bP3Jh')
                .then((result) => {
                    console.log(result.text);
                }, (error) => {
                    console.log(error.text);
                });
            e.target.reset()
        }
    }

    function ContactCard(props) {
        return (
            <div className="contact_card">
                <div className="icon">
                    <i className={props.classname} aria-hidden="true"></i>
                </div>
                <div className="text">
                    <h5>{props.title}</h5>
                    <a href={props.link}>{props.linkname}</a>
                </div>
            </div>
        )
    }

    function Socialmedia(props) {
        return (
            <li>
                <a href={props.link} target="_blank"><i className={props.iconclass}></i></a>
            </li>
        )
    }

    return (
        <section id="contact">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <PageTitle Pageinfo="Contact" Pagename="Get in" Highlight="touch" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4">
                        <div className="contact-infos">
                            <h4>Feel free to contact us!</h4>
                            <p>
                                Feel free to get in touch with me. I am always open to discussing new projects, creative ideas or opportunities to be part of your visions.
                            </p>
                            <div className="personal_contact">
                                <ContactCard classname="fa fa-envelope-open" title="Mail me" linkname="contactiftekhar@gmail.com" link="mailto:contactiftekhar@gmail.com" />
                                <ContactCard classname="fa fa-phone-square" title="Call me" linkname="01533501236" link="tel:+8801533501236" />
                            </div>
                            <ul>
                                <Socialmedia link="https://facebook.com" iconclass="fa fa-facebook" />
                                <Socialmedia link="https://twitter.com" iconclass="fa fa-twitter" />
                                <Socialmedia link="https://linkedin.com" iconclass="fa fa-linkedin" />
                                <Socialmedia link="https://dribbble.com" iconclass="fa fa-dribbble" />
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <form className="contact-form" onSubmit={sendEmail}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <input type="text" id="name" name="name" placeholder="Your Name" />
                                        </div>
                                        <div className="col-lg-4">
                                            <input type="text" id="subject" name="subject" placeholder="Your Subject" />
                                        </div>
                                        <div className="col-lg-4">
                                            <input type="email" id="email" name="email" placeholder="Your email" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <textarea name="message" id="message" placeholder="Your message" />
                                </div>
                                <div className="col-lg-12">
                                    <button type="submit" className="primaryBtn">Sent <i class="fa fa-paper-plane-o" aria-hidden="true"></i></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}
